<template>
  <div class="personinfo-card">
    <div class="card-title">
      <img class="icon" src="../icons/icon/学习经历.png" alt="" />
      <span class="title">学习经历(从高中填起)</span>
      <!-- <span class="family-title-fontSize2" @click="add" v-show="addFlag">
      新增附件
      </span>
      <span class="family-title-fontSize2" v-show="addFlag2" @click="submit">
      保存
      </span> -->
      <div class="opt-right">
        <el-button
          @click="add"
          :disabled="isDisabled"
          type="primary"
          size="mini"
          ><i class="el-icon-plus el-icon--left"></i>新增</el-button
        >
      </div>
    </div>

    <div class="card-body">
      <div
        class="body-item"
        v-for="(formData, index) in formDatas"
        v-bind:key="index"
      >
        <div class="body-item-tools">
          <i
            class="el-icon-delete delete"
            @click="removeData(formData.oid)"
            v-show="isDisabled == false"
          ></i>
        </div>

        <el-form
          :inline="true"
          :model="formData"
          ref="formData"
          class="form_data"
          label-width="140px"
          :rules="rules"
          size="medium"
          :disabled="isDisabled"
        >
          <div class="cs">
            <el-form-item label="学历层次" prop="edulevel">
              <el-select
                v-model="formData.edulevel"
                clearable
                @change="changeEdulevel($event, index, formData)"
              >
                <el-option
                  v-for="item in eduList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="所学专业"
              prop="major"
              :rules="
                isFieldEnable(formData.edulevel)
                  ? rules.major
                  : [{ required: false }]
              "
            >
              <el-input v-model="formData.major" :maxlength="120" />
            </el-form-item>
          </div>
          <div class="cs">
            <el-form-item label="毕(结、肄)业时间" prop="gradudate">
              <el-date-picker
                v-model="formData.gradudate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @input="changeGradudate($event, index, formData)"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="毕(结、肄)业学校" prop="school">
              <el-input v-model="formData.school" :maxlength="120" />
            </el-form-item>
          </div>
          <div class="cs">
            <el-form-item label="学习形式" prop="learnway">
              <SelectTree
                v-model="formData.learnway"
                :treeData="learnwayListTree"
              ></SelectTree>
            </el-form-item>
            <el-form-item label="学位" prop="degree">
              <SelectTree
                v-model="formData.degree"
                :treeData="degreeListTree"
                @change="changeDegree($event, index, formData)"
                :disabled="degreeDisabled[index]"
              ></SelectTree>
            </el-form-item>
          </div>
          <div class="cs">
            <el-form-item label="是否第一学历" prop="isfirst">
              <el-select v-model="formData.isfirst">
                <el-option :label="'是'" :value="'Y'"></el-option>
                <el-option :label="'否'" :value="'N'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              style="margin-bottom: 20px"
              label="是否最高学历"
              prop="ishigh"
            >
              <el-select v-model="formData.ishigh">
                <el-option :label="'是'" :value="'Y'"></el-option>
                <el-option :label="'否'" :value="'N'"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="cs">
            <el-form-item label="学校类别" prop="schooltype">
              <el-select v-model="formData.schooltype">
                <el-option
                  v-for="item in schooltypeList"
                  :key="item.oid"
                  :label="item.name"
                  :value="item.oid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="imgs">
            <div v-for="eduimg in edufileView" :key="'edu_' + eduimg.oid">
              <div
                v-show="eduimg.oid == formData.oid && eduimg.divshow"
                class="resume-img"
              >
                <div
                  v-on:mouseover="
                    mouseoverImg(eduimg.img, formData.oid, 'edufile')
                  "
                  v-on:mouseout="mouseoutImg(formData.oid, 'edufile')"
                  class="imgcontent"
                >
                  <div
                    @click="avatarUpload(formData.oid, index, 'edufile')"
                    class="imgspan"
                  >
                    <span
                      v-show="eduimg.spanshow"
                      disable
                      style="
                        -webkit-user-select: none;
                        user-select: none;
                        display: inline-block;
                        position: absolute;
                        height: 60px;
                        line-height: 60px;
                        left: 105px;
                        top: 40px;
                        font-size: 50px;
                        font-family: '黑体';
                        color: #cccccc;
                      "
                    >
                      +
                    </span>
                    <span
                      v-show="eduimg.spanshow"
                      style="
                        -webkit-user-select: none;
                        user-select: none;
                        display: inline-block;
                        position: absolute;
                        height: 40px;
                        line-height: 40px;
                        left: 75px;
                        top: 80px;
                        font-size: 21px;
                        font-family: '黑体';
                        color: #409eff;
                      "
                    >
                      学历证书</span
                    >
                    <img v-show="eduimg.imgshow" :src="eduimg.img" />
                  </div>
                  <div v-show="eduimg.deleteshow" class="delete-img">
                    <i
                      class="el-icon-delete"
                      @click="deleteImg(formData.oid, 'edufile')"
                    ></i>
                  </div>
                </div>
                <input
                  type="file"
                  ref="edufileFile"
                  style="display: none"
                  @change="avatarUploadFile('edufile')"
                />
              </div>
            </div>
            <div
              v-for="eduthimg in eduauthfileView"
              :key="'eduth_' + eduthimg.oid"
            >
              <div
                v-show="eduthimg.oid == formData.oid && eduthimg.divshow"
                class="resume-img"
              >
                <div
                  v-on:mouseover="
                    mouseoverImg(eduthimg.img, formData.oid, 'eduauthfile')
                  "
                  v-on:mouseout="mouseoutImg(formData.oid, 'eduauthfile')"
                  class="imgcontent"
                >
                  <div
                    @click="avatarUpload(formData.oid, index, 'eduauthfile')"
                    class="imgspan"
                  >
                    <span
                      v-show="eduthimg.spanshow"
                      disable
                      style="
                        -webkit-user-select: none;
                        user-select: none;
                        display: inline-block;
                        position: absolute;
                        height: 60px;
                        line-height: 60px;
                        left: 105px;
                        top: 40px;
                        font-size: 50px;
                        font-family: '黑体';
                        color: #cccccc;
                      "
                    >
                      +
                    </span>
                    <span
                      v-show="eduthimg.spanshow"
                      style="
                        -webkit-user-select: none;
                        user-select: none;
                        display: inline-block;
                        position: absolute;
                        height: 40px;
                        line-height: 40px;
                        left: 60px;
                        top: 80px;
                        font-size: 21px;
                        font-family: '黑体';
                        color: #409eff;
                      "
                    >
                      学历认证报告</span
                    >
                    <img v-show="eduthimg.imgshow" :src="eduthimg.img" />
                  </div>
                  <div v-show="eduthimg.deleteshow" class="delete-img">
                    <i
                      class="el-icon-delete"
                      @click="deleteImg(formData.oid, 'eduauthfile')"
                    ></i>
                  </div>
                </div>
                <input
                  type="file"
                  ref="eduauthfileFile"
                  style="display: none"
                  @change="avatarUploadFile('eduauthfile')"
                />
              </div>
            </div>
            <div v-for="deimg in defileView" :key="'de_' + deimg.oid">
              <div
                v-show="deimg.oid == formData.oid && deimg.divshow"
                class="resume-img"
              >
                <div
                  v-on:mouseover="
                    mouseoverImg(deimg.img, formData.oid, 'defile')
                  "
                  v-on:mouseout="mouseoutImg(formData.oid, 'defile')"
                  class="imgcontent"
                >
                  <div
                    @click="avatarUpload(formData.oid, index, 'defile')"
                    class="imgspan"
                  >
                    <span
                      v-show="deimg.spanshow"
                      disable
                      style="
                        -webkit-user-select: none;
                        user-select: none;
                        display: inline-block;
                        position: absolute;
                        height: 60px;
                        line-height: 60px;
                        left: 105px;
                        top: 40px;
                        font-size: 50px;
                        font-family: '黑体';
                        color: #cccccc;
                      "
                    >
                      +
                    </span>
                    <span
                      v-show="deimg.spanshow"
                      style="
                        -webkit-user-select: none;
                        user-select: none;
                        display: inline-block;
                        position: absolute;
                        height: 40px;
                        line-height: 40px;
                        left: 75px;
                        top: 80px;
                        font-size: 21px;
                        font-family: '黑体';
                        color: #409eff;
                      "
                    >
                      学位证书</span
                    >

                    <img v-show="deimg.imgshow" :src="deimg.img" />
                  </div>
                  <div v-show="deimg.deleteshow" class="delete-img">
                    <i
                      class="el-icon-delete"
                      @click="deleteImg(formData.oid, 'defile')"
                    ></i>
                  </div>
                </div>
                <input
                  type="file"
                  ref="defileFile"
                  style="display: none"
                  @change="avatarUploadFile('defile')"
                />
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
// import { dictData } from '../request/resumeApi';
import { mapActions } from "vuex";
import { ListToTree } from "../../utils/tools";
import { avatarUpload, avatarDownloadBase64 } from "../request/api";
import SelectTree from "../../components/widget/SelectTree";

export default {
  components: {
    SelectTree,
  },
  props: {
    VOStatus: {
      type: String,
      default: () => {
        return "view";
      },
    },
    studyData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    formFlag: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    avatarUploadParams: {
      type: Object,
      default() {
        return {
          isWeb: "true",
          isYES2: "true",
          mode: "1",
          service: "UploadAttachment",
          cmd: "UploadResumeImage",
          formKey: "MyResumeLib",
          oid: "-1",
          deleteOld: "1",
        };
      },
    },
  },
  data() {
    return {
      // 用户填写信息
      formDatas: [],
      formDataNew: [],
      //学历证书
      edufileView: [],
      //学历认证报告
      eduauthfileView: [],
      //学位证书
      defileView: [],
      currentRow: 0,
      currentOid: 0,
      studyForm: {
        oid: 0,
        edulevel: "",
        major: "",
        learnway: "",
        school: "",
        schooltype: "",
        gradudate: "",
        degree: "",
        isfirst: "",
        ishigh: "",
        edufile: "",
        eduauthfile: "",
        defile: "",
      },
      // //学历证书
      // edufileShow: [],
      // //学历认证报告
      // eduauthfileShow: [],
      // //学位证书
      // defileShow: [],
      //学位是否可选
      degreeDisabled: [],
      currentLiStyle: 0,
      flag: true,
      familyFlag: false,
      addFlag: true,
      addFlag2: false,
      rules: {
        edulevel: [
          { required: true, message: "请输入学习层次", trigger: "blur" },
        ],
        learnway: [
          { required: true, message: "请输入学习形式", trigger: "blur" },
        ],
        school: [
          {
            required: true,
            message: "请输入毕(结、肄)业学校",
            trigger: "blur",
          },
          // { max: 120, message: '不能超过120个字符', trigger: 'blur' }
        ],
        schooltype: [
          { required: true, message: "请输入学校类别", trigger: "blur" },
        ],
        major: [
          { required: true, message: "请输入所学专业", trigger: "blur" },
          // { max: 120, message: '不能超过120个字符', trigger: 'blur' }
        ],
        degree: [
          {
            required: true,
            message: "请输入学位",
            trigger: "blur",
          },
        ],
        isfirst: [
          {
            required: true,
            message: "请输入是否是第一",
            trigger: "blur",
          },
        ],
        ishigh: [
          { required: true, message: "请输入是否是最高学历", trigger: "blur" },
        ],
        gradudate: [
          {
            type: "string",
            required: true,
            message: "请选择毕(结、肄)业时间",
            trigger: "change",
          },
        ],
      },
      assinList: [], //赋值
      addNewList: [], //新增
      eduList: [],
      learnwayList: [],
      degreeList: [],
      schooltypeList: [],
    };
  },
  mounted() {
    // bd_commonedu  bd_edulevel 学历
    this.dictData("bd_commonedu", "eduList", false);

    this.dictData("bd_learnway", "learnwayList", false);
    this.dictData("bd_degree", "degreeList", false);
    this.dictData("bd_schooltype", "schooltypeList", false);
    this.initForm();
  },
  computed: {
    isDisabled: function () {
      if (this.$props.VOStatus == "view") {
        return true;
      } else if (this.$props.VOStatus == "edit") {
        return false;
      } else if (this.$props.VOStatus == "new") {
        return false;
      }
      return true;
    },
    learnwayListTree: function () {
      if (!this.learnwayList || this.learnwayList.length == 0) {
        return [];
      }

      // 转化为tree
      return ListToTree(this.learnwayList, 0);
    },
    degreeListTree: function () {
      if (!this.degreeList || this.degreeList.length == 0) {
        return [];
      }

      // 转化为tree
      return ListToTree(this.degreeList, 0);
    },
  },
  methods: {
    ...mapActions(["globalDictDataRequest"]),

    // 鼠标移入图片
    mouseoverImg(img, oid, type) {
      if (this.isDisabled) {
        return;
      }
      if (img != null && img != "") {
        this[type + "View"].map((item) => {
          if (item.oid == oid) {
            item.deleteshow = true;
          }
        });
      }
    },
    // 鼠标移出图片
    mouseoutImg(oid, type) {
      if (this.isDisabled) {
        return;
      }
      this[type + "View"].map((item) => {
        if (item.oid == oid) {
          item.deleteshow = false;
        }
      });
    },
    // 删除图片
    deleteImg(oid, types) {
      this.$confirm("是否删除该照片?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //更新图片信息
          this[types + "View"].map((item) => {
            if (item.oid == oid) {
              item.img = null;
              item.imgshow = false;
              item.spanshow = true;
              item.deleteshow = false;
            }
            //删除图片后将表中数据置为空
            for (let index in this.formDatas) {
              if (this.formDatas[index].oid == oid) {
                if (types == "edufile") {
                  this.formDatas[index].edufile = null;
                } else if (types == "eduauthfile") {
                  this.formDatas[index].eduauthfile = null;
                } else if (types == "defile") {
                  this.formDatas[index].defile = null;
                }
              }
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //获取字典
    dictData(type, list, isBlank) {
      // let data = {
      //   type: type
      // }
      // dictData(data, isBlank).then(response => {
      //   // console.log(response)
      //   this[list] = response.data
      // });

      return this.globalDictDataRequest({ key: type, cacheName: list }).then(
        (res) => {
          // 深拷贝数据
          let data = [...res].map((item) => {
            return { ...item };
          });
          if (isBlank) {
            data.unshift({
              name: "请选择...",
              code: "0",
              oid: 0,
            });
          }
          this[list] = data;
          return res;
        }
      );
    },
    //字段是否必输
    isFieldEnable(dictOid) {
      let edunameres = this.eduList.filter(
        (item) =>
          item.oid == dictOid &&
          (item.name == "高中" ||
            item.name == "初中" ||
            item.name == "小学" ||
            item.name == "其他")
      );
      if (edunameres && edunameres.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    //如果大专以上，都显示，大专以下，则只显示学历证书
    changeEdulevel(dictOid, index, formData) {
      //学历层次
      let edulevel = this.checkEduLevel(dictOid);
      //如果大专以上学历
      if (edulevel) {
        this.edufileView[index].divshow = true;
        this.eduauthfileView[index].divshow = true;
        let hasDegree = this.checkHasDegree(formData.degree);
        //如果有学位
        if (hasDegree) {
          this.defileView[index].divshow = true;
        } else {
          this.defileView[index].divshow = false;
        }
        this.degreeDisabled[index] = false;
      } else {
        //如果大专及以下学历
        this.eduauthfileView[index].divshow = false;
        this.defileView[index].divshow = false;
        formData.degree = 249497; //"无学位";
        this.degreeDisabled[index] = true;
      }

      //学历无所谓，如果已毕业
      let isGrade = this.checkIsGrade(formData.gradudate);
      if (isGrade) {
        this.edufileView[index].divshow = true;
      } else {
        //如果未毕业
        this.edufileView[index].divshow = false;
        this.defileView[index].divshow = false;
        this.eduauthfileView[index].divshow = false;
      }
    },
    //毕业时间未发生时，不需要上传所有证件
    changeGradudate(date, index, formData) {
      let isGrade = this.checkIsGrade(date);
      //已毕业
      if (isGrade) {
        this.edufileView[index].divshow = true;
        //判断学历层次
        let edulevel = this.checkEduLevel(formData.edulevel);
        if (edulevel) {
          //大专以上学历
          this.eduauthfileView[index].divshow = true;
        } else {
          //大专及以下学历
          this.eduauthfileView[index].divshow = false;
        }
        //判断是否有学位
        let hasDegree = this.checkHasDegree(formData.degree);
        if (hasDegree) {
          //如果有学位
          this.defileView[index].divshow = true;
        } else {
          //如果无学位
          this.defileView[index].divshow = false;
        }
      } else {
        //未毕业
        this.isGrade = false;
        this.edufileView[index].divshow = false;
        this.eduauthfileView[index].divshow = false;
        this.defileView[index].divshow = false;
      }
    },
    //学位变化时，如果为无学位，则学位证书附件上传不显示
    changeDegree(dictOid, index, formData) {
      let hasDegree = this.checkHasDegree(dictOid);
      //如果有学位
      if (hasDegree) {
        //判断学历
        let edulevel = this.checkEduLevel(formData.edulevel);
        if (edulevel) {
          //如果大专以上
          this.defileView[index].divshow = true;
          this.eduauthfileView[index].divshow = true;
          this.edufileView[index].divshow = true;
        } else {
          //如果大专及以下
          this.defileView[index].divshow = false;
          this.eduauthfileView[index].divshow = false;
          this.edufileView[index].divshow = false;
        }
      } else {
        //如果无学位
        this.defileView[index].divshow = false;
      }

      //如果已毕业
      let isGrade = this.checkIsGrade(formData.gradudate);
      if (isGrade) {
        this.edufileView[index].divshow = true;
      } else {
        //如果未毕业
        this.edufileView[index].divshow = false;
        this.defileView[index].divshow = false;
        this.eduauthfileView[index].divshow = false;
      }
    },
    checkIsGrade(date) {
      if (date != null) {
        //如果填写时间大于当前时间，则未毕业
        if (new Date(date) > new Date()) {
          return false;
        } else {
          return true;
        }
      } else {
        //如果日期还未选择，则当成已毕业
        return true;
      }
    },
    checkEduLevel(dictOid) {
      if (dictOid == null || dictOid == "") {
        return true;
      }
      let edunameres = this.eduList.filter(
        (item) =>
          item.oid == dictOid &&
          (item.name == "博士研究生" ||
            item.name == "硕士研究生" ||
            item.name == "大学本科")
      );
      //如果是大专以上
      if (edunameres && edunameres.length > 0) {
        return true;
      } else {
        //如果是大专及以下
        return false;
      }
    },
    checkHasDegree(dictOid) {
      if (dictOid == null || dictOid == "") {
        return true;
      }
      let edunameres = this.degreeList.filter(
        (item) => item.oid == dictOid && item.name == "无学位"
      );
      //如果无学位
      if (edunameres && edunameres.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    degreeListComputed(formData) {
      if (formData.learnway == "") {
        return [];
      }
      return this.degreeList.filter(
        (item) => item["parentid"] == formData.learnway
      );
    },
    //新增成员
    add() {
      let newOid = new Date().getTime();
      this.formDataNew.push(newOid);

      this.formDatas.push({
        oid: newOid,
        edulevel: "",
        major: "",
        learnway: "",
        school: "",
        schooltype: "",
        gradudate: "",
        degree: "",
        isfirst: "",
        ishigh: "",
        edufile: "",
        eduauthfile: "",
        defile: "",
      });
      this.edufileView.push({
        oid: newOid,
        img: "",
        imgshow: false,
        spanshow: true,
        deleteshow: false,
        divshow: true,
      });

      this.eduauthfileView.push({
        oid: newOid,
        img: "",
        imgshow: false,
        spanshow: true,
        deleteshow: false,
        divshow: true,
      });

      this.defileView.push({
        oid: newOid,
        img: "",
        imgshow: false,
        spanshow: true,
        deleteshow: false,
        divshow: true,
      });
    },
    removeData(oid) {
      this.formDatas = this.formDatas.filter((item) => oid != item.oid);
      this.formDataNew = this.formDataNew.filter((item) => oid != item);
    },
    clearFormData() {
      // 重置数据
      this.formDatas = [];
      this.formDataNew = [];
    },
    resetFormData() {
      // 重置数据
      if (
        !this.$refs.formData ||
        !this.$refs.formData.length ||
        this.$refs.formData.length == 0
      ) {
        return;
      }

      for (let index in this.$refs.formData) {
        this.$refs.formData[index].resetFields();
      }
    },
    formAllValidate() {
      // 表单验证
      return new Promise(
        function (resolve) {
          var validateAll = [];
          // for (let index in this.$refs.formData) {
          //   validateAll.push(this.$refs.formData[index].validate());
          // }

          Promise.all(validateAll)
            .then((values) => {
              // 只能有一条第一学历和一条最高学历
              if (!this.formDatas || this.formDatas.length < 1) {
                resolve({
                  type: "studyExp",
                  status: "fail",
                  msg: "学习经历需要添加至少一条!",
                });
                return;
              }
              let isfirstSize = 0;
              let ishighSize = 0;
              for (let index in this.formDatas) {
                if (this.formDatas[index].isfirst == "Y") {
                  // 第一学历加一
                  isfirstSize++;
                }
                if (this.formDatas[index].ishigh == "Y") {
                  // 最高学历加一
                  ishighSize++;
                }
              }
              if (isfirstSize > 1 || ishighSize > 1) {
                resolve({
                  type: "studyExp",
                  status: "fail",
                  msg: "只能有一条第一学历和一条最高学历",
                });
                return;
              }
              // let isHasImage = 0;
              // let isHasAll = 0;
              // let isHasDegree = 0;

              for (let index in this.formDatas) {
                //如果目前还未毕业，则所有附件均不必传
                if (new Date(this.formDatas[index].gradudate) > new Date()) {
                  continue;
                }
                //如果学历为大学专科以上（大学本科、硕士、博士）
                if (
                  this.formDatas[index].edulevel == 373782 ||
                  this.formDatas[index].edulevel == 373783 ||
                  this.formDatas[index].edulevel == 373784
                ) {
                  //判断是否有学位（无学位）
                  if (this.formDatas[index].degree == 249497) {
                    //判断是否上传除学位证之外的证明
                    if (
                      this.formDatas[index].edufile == null ||
                      this.formDatas[index].edufile == ""
                    ) {
                      resolve({
                        type: "studyExp",
                        status: "fail",
                        msg: "学历证书必须上传图片",
                      });
                      return;
                    }

                    if (
                      this.formDatas[index].eduauthfile == null ||
                      this.formDatas[index].eduauthfile == ""
                    ) {
                      resolve({
                        type: "studyExp",
                        status: "fail",
                        msg: "学历认证报告必须上传图片",
                      });
                      return;
                    }
                  } else {
                    //如有学位
                    if (
                      this.formDatas[index].edufile == null ||
                      this.formDatas[index].edufile == ""
                    ) {
                      resolve({
                        type: "studyExp",
                        status: "fail",
                        msg: "学历证书必须上传图片",
                      });
                      return;
                    }

                    if (
                      this.formDatas[index].eduauthfile == null ||
                      this.formDatas[index].eduauthfile == ""
                    ) {
                      resolve({
                        type: "studyExp",
                        status: "fail",
                        msg: "学历认证报告必须上传图片",
                      });
                      return;
                    }

                    if (
                      this.formDatas[index].defile == null ||
                      this.formDatas[index].defile == ""
                    ) {
                      resolve({
                        type: "studyExp",
                        status: "fail",
                        msg: "学位证书必须上传图片",
                      });
                      return;
                    }
                  }
                } else {
                  //学历为大学专科及以下
                  if (
                    this.formDatas[index].edufile == null ||
                    this.formDatas[index].edufile == ""
                  ) {
                    resolve({
                      type: "studyExp",
                      status: "fail",
                      msg: "学历证书必须上传图片",
                    });
                    return;
                  }
                }
              }
              resolve({
                type: "studyExp",
                status: "ok",
                msg: "验证通过",
              });
            })
            .catch((e) => {
              resolve({
                type: "studyExp",
                status: "fail",
                msg: "【学习经历】页签验证不通过",
              });
            });
        }.bind(this)
      );
    },
    formGetValue() {
      // 页面获取值
      // this.formDatas.sort((a, b) => {
      //   try {
      //     let a_code = this.eduList.filter(item=>item.oid=a.edulevel)[0].code;
      //     let b_code = this.eduList.filter(item=>item.oid=b.edulevel)[0].code;
      //     if(a_code < b_code) {
      //       return -1;
      //     } else if(a_code > b_code) {
      //       return -1;
      //     } else {
      //       return Date.parse(a.gradudate) - Date.parse(b.gradudate);
      //     }
      //   } catch (error) {
      //     console.log(error)
      //     return 0;
      //   }
      // });
      return this.formDatas.map((item) => {
        if (this.formDataNew.includes(item.oid)) {
          item.oid = 0;
        }
        return item;
      });
    },

    setFormDatas(datas) {
      // 设置数据
      //保存后加载数据清理view中的缓存数据
      this["edufileView"] = [];
      this["eduauthfileView"] = [];
      this["defileView"] = [];

      this.formDatas = datas.map((item) => {
        var newItem = {};

        for (let key in this.studyForm) {
          if (item[key]) {
            if (key == "edufile" || key == "eduauthfile" || key == "defile") {
              newItem[key] = item[key].key;
              this[key + "View"].push({
                oid: item["oid"].key,
                img: "",
                imgshow: false,
                spanshow: true,
                deleteshow: false,
                divshow: false,
              });

              if (item[key].key) {
                avatarDownloadBase64(item[key].key).then((img) => {
                  if (img.data) {
                    this[key + "View"].map((itemview) => {
                      if (itemview.oid == item["oid"].key) {
                        (itemview.img = img.data),
                          (itemview.divshow = true),
                          (itemview.imgshow = true),
                          (itemview.spanshow = false),
                          (itemview.deleteshow = false);
                      }
                    });
                  }
                });
              }
            } else {
              newItem[key] = item[key].key;
            }
          }
        }
        newItem["oid"] = item["oid"].key;
        return newItem;
      });

      //校验图片divshow状态
      for (let i = 0; i < this.formDatas.length; i++) {
        debugger
        let item = this.formDatas[i];
        let isGrade = this.checkIsGrade(item.gradudate);
        //数据关系对应
        if (this.edufileView[i].oid == item.oid) {
          this.edufileView[i].divshow = true;
          //未毕业
          if (!isGrade) {
            this.edufileView[i].divshow = false;
          }
        }
        if (this.eduauthfileView[i].oid == item.oid) {
          let edulevel = this.checkEduLevel(item.edulevel);
          if (edulevel) {
            //大专以上
            this.eduauthfileView[i].divshow = true;
          } else {
            this.degreeDisabled[i] = true;
          }
          //未毕业
          if (!isGrade) {
            this.eduauthfileView[i].divshow = false;
          }
        }
        if (this.defileView[i].oid == item.oid) {
          let hasDegree = this.checkHasDegree(item.degree);
          //有学位
          if (hasDegree) {
            this.defileView[i].divshow = true;
          }
          //未毕业
          if (!isGrade) {
            this.defileView[i].divshow = false;
          }
        }
      }
    },

    //保存
    submit() {
      this.addFlag = !this.addFlag;
      this.addFlag2 = !this.addFlag2;
      this.familyFlag = !this.familyFlag;
      this.flag = !this.flag;
      this.assinList.push({
        edulevel: { value: this.studyForm.edulevel },
        major: { value: this.studyForm.major },
        learnway: { value: this.studyForm.learnway },
        school: { value: this.studyForm.school },
        schooltype: { value: this.studyForm.schooltype },
        gradudate: { value: this.studyForm.gradudate },
        degree: { value: this.studyForm.degree },
        isfirst: { value: this.studyForm.isfirst },
        ishigh: { value: this.studyForm.ishigh },
        edufile: { value: this.studyForm.edufile },
        eduauthfile: { value: this.studyForm.eduauthfile },
        defile: { value: this.studyForm.defile },
      });
      this.addNewList.push({
        edulevel: this.studyForm.edulevel,
        major: this.studyForm.major,
        learnway: this.studyForm.learnway,
        school: this.studyForm.school,
        schooltype: this.studyForm.schooltype,
        gradudate: this.studyForm.gradudate,
        degree: this.studyForm.degree,
        isfirst: this.studyForm.isfirst,
        ishigh: this.studyForm.ishigh,
        edufile: { value: this.studyForm.edufile },
        eduauthfile: { value: this.studyForm.eduauthfile },
        defile: { value: this.studyForm.defile },
      });
      // this.$refs['studyForm'].resetFields()
    },
    //表单初始化
    initForm() {
      if (this.formFlag == 1) {
        this.familyFlag = false;
      } else {
        this.addFlag = !this.addFlag;
        this.addFlag2 = !this.addFlag2;
        this.familyFlag = !this.familyFlag;
        this.flag = !this.flag;
      }
    },
    //提交表单
    // validForm() {
    //   this.$refs['studyForm'].validate((valid) => {
    //     if (valid) {
    //       this.flag = true;
    //       //  this.resetForm(formName)
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    //家庭成员选中框
    familyView(index) {
      this.currentLiStyle = index;
    },
    //  表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    avatarUpload(oid, rownum, type) {
      if (this.isDisabled) {
        return;
      }
      this.currentRow = rownum;
      this.currentOid = oid;
      this.$refs[type + "File"][rownum].click();
    },

    avatarUploadFile(type) {
      var rownum = this.currentRow;
      var oid = this.currentOid;

      if (this.$refs[type + "File"][rownum].files) {
        let filedata = this.$refs[type + "File"][rownum].files[0];

        if (!filedata) {
          this.$message.error("请重新上传图片!");
          return;
        }

        //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
        let fileType = filedata.name
          .substring(filedata.name.lastIndexOf(".") + 1, filedata.name.length)
          .toUpperCase();
        if (!this.beforeAvatarUpload(fileType)) {
          return;
        }

        //图片大小校验
        let filesize = (filedata.size / 1024).toFixed(2);
        if (filesize > 600) {
          this.$message.error("图片大小不能超过600KB!");
          return;
        }

        let formData = new FormData();
        formData.append("file", filedata);

        for (let item in this.avatarUploadParams) {
          formData.append(item, this.avatarUploadParams[item]);
        }

        avatarUpload(formData).then((res) => {
          if (res.data && res.data.Name == -1) {
            this.$message.error(res.data.Message);
              return;
          }
          // 上传完成后，给formdata赋值
          this.formDatas.map((item) => {
            if (item.oid == oid) {
              item[type] = res.data.Path;
            }
          });
          if (res.data.Path && res.data.Path != null) {
            // 根据图片显示
            avatarDownloadBase64(res.data.Path).then((img) => {
              if (img.data) {
                this[type + "View"].map((item) => {
                  if (item.oid == oid) {
                    item.img = img.data;
                    item.imgshow = true;
                    item.spanshow = false;
                  }
                });
              }
            });
          }
        });
      }
    },
    beforeAvatarUpload(type) {
      const isJPEG = type === "JPEG";
      const isJPG = type === "JPG";
      const isBMP = type === "BMP";
      const isPNG = type === "PNG";
      const isGIF = type === "GIF";

      if (!isJPEG && !isJPG && !isBMP && !isPNG && !isGIF) {
        this.$message.error(
          "格式错误，上传图片只能是 JPG、BMP、GIF、PNG、JPEG 格式!"
        );
        return false;
      } else return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.personinfo-card {
  // line-height: 40px;
  width: 960px;
  // margin-left: 14px;
  // margin-right: 2px;

  .card-title {
    position: relative;

    // border-bottom: 1px solid #ebebeb;
    margin-bottom: 20px;

    .icon {
      display: inline-block;
      height: 40px;
      vertical-align: middle;
    }

    .title {
      line-height: 40px;
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      color: #01539f;
      vertical-align: middle;
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -12px;
      height: 1px;
      background: #ebebeb;
    }

    .opt-right {
      position: absolute;
      right: 12px;
      top: 0px;
      height: 40px;
      line-height: 40px;

      .el-button {
        border: none;
        border-radius: 0px;
      }
    }
  }

  .card-body {
    .body-item {
      border: 1px solid #eee;
      border-radius: 12px;
      padding: 12px;
      margin-bottom: 20px;
      width: 100%;
      height: 100%;

      .imgs {
        width: 100%;
        height: 156px;
        margin-bottom: 10px;

        .resume-img {
          float: left;
          width: 240px;
          height: 166px;
          background-color: #f5f7f9;
          margin-left: 50px;
          top: 0px;
          overflow: hidden;
          position: relative;

          .imgcontent {
            height: 100%;
          }

          .imgspan {
            height: 100%;
            display: flex;
            text-align: center;
            vertical-align: middle;
            align-items: center;
          }

          .delete-img {
            position: absolute;
            width: 240px;
            height: 30px;
            line-height: 30px;
            bottom: 1px;
            background: rgba(59, 60, 61, 0.5);
            z-index: 999;
            cursor: pointer;
            text-align: right;

            i {
              margin: 8px 10px 0 0;
              display: relative;
              font-size: 14px;
              color: white;
            }
          }

          img {
            width: auto;
            height: auto;
            max-width: 240px;
            max-height: 166px;
            margin: 0 auto;
          }
        }
      }
    }

    .body-item-tools {
      height: 30px;

      .delete {
        float: right;
        margin-top: 6px;
        font-size: 18px;
        color: rgba(255, 0, 0, 0.85);
        cursor: pointer;
      }

      .delete:hover {
        color: rgba(255, 0, 0);
      }

      .delete:active {
        opacity: 0.5;
      }
    }

    // .form_data {}
  }
}

.form_data {
  .el-input {
    width: 310px;
  }

  .el-select {
    width: 310px;
  }

  .awardcorp-wrap {
    .el-textarea__inner {
      resize: none;
    }
  }
}

// ::v-deep .el-select {}
</style>
